import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

// Same links as before, grouped by purpose.
const LINK_GROUPS = [
  {
    title: 'Tools',
    links: [
      ['/optionchain', 'Option Trading Wala'],
      ['/backtester', 'Back Tester'],
      ['/strong-sr-stock', 'Triple S/R'],
      ['/sr-stock', 'S/R stocks'],
      ['/dailyanalysis', 'Daily Analysis'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['/about', 'About Us'],
      ['/contact', 'Contact Us'],
      ['/blog', 'Blogs'],
      ['/pricing', 'Pricing'],
    ],
  },
  {
    title: 'Legal',
    links: [
      ['/privacy-policy', 'Privacy Policy'],
      ['/term-and-services', 'Terms of Service'],
      ['/cancelpolicy', 'Cancellation & Refund Policy'],
    ],
  },
]

const SOCIAL = [
  ['img/chain-hyperlink.svg', 'Option Chain'],
  ['img/chain-hyperlink-email.svg', 'Email'],
  ['img/chain-hyperlink-youtube.svg', 'YouTube'],
  ['img/chain-hyperlink-telegram.svg', 'Telegram'],
]

function Footer() {
  return (
    <footer className="otw-footer mt-auto">
      <div className="otw-footer-inner">
        <div className="otw-footer-brand">
          <a href="/" className="otw-footer-logo"><img src="img/header-logo.svg" alt="Option Trading Wala" /></a>
          <p className="otw-footer-tagline">
            Option chain analytics, support / resistance and backtesting for Indian markets.
          </p>
          <ul className="otw-footer-social">
            {SOCIAL.map(([src, label]) => (
              <li key={label}>
                <a href="#" target="_blank" rel="noopener noreferrer" aria-label={label} title={label}>
                  <img src={src} alt={label} loading="lazy" />
                </a>
              </li>
            ))}
          </ul>
        </div>

        {LINK_GROUPS.map((group) => (
          <nav key={group.title} className="otw-footer-col" aria-label={group.title}>
            <h2>{group.title}</h2>
            <ul>
              {group.links.map(([to, label]) => (
                <li key={to}><Link to={to}>{label}</Link></li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="otw-footer-bottom">
        <p>© {new Date().getFullYear()} Option Trading Wala · Made of Option Chain</p>
      </div>
    </footer>
  )
}

export default Footer
